import React from 'react';
import { motion } from 'framer-motion';
export function PartnersSection() {
  const partners = [{
    name: 'CQ Business Consulting Inc.',
    type: 'Lead Partner'
  }, {
    name: 'Pitch Better',
    type: 'Research Partner'
  }, {
    name: 'SBCCI',
    type: 'Community Capital'
  }, {
    name: 'Ecosystem Contributors',
    type: 'Ecosystem Contributor'
  }];
  return <section className="py-20 bg-white" data-id="element-170">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center" data-id="element-171">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-sm font-bold text-gray-400 uppercase tracking-widest mb-12" data-id="element-172">
          Built in collaboration with
        </motion.h2>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-center" data-id="element-173">
          {partners.map((partner, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="flex flex-col items-center justify-center p-6 grayscale hover:grayscale-0 transition-all duration-500 opacity-70 hover:opacity-100" data-id="element-174">
              <div className="font-serif text-xl md:text-2xl font-bold text-brand-black text-center leading-tight" data-id="element-175">
                {partner.name}
              </div>
              <div className="text-xs text-brand-teal font-medium mt-2 uppercase tracking-wider" data-id="element-176">
                {partner.type}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}